import { render, staticRenderFns } from "./relatorioPropostasPaisagem.vue?vue&type=template&id=acb94d2e"
import script from "./relatorioPropostasPaisagem.vue?vue&type=script&lang=js"
export * from "./relatorioPropostasPaisagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports